module.exports = "<img (click)=\"openModal(template2)\" class=\"ml-3 icon-size\" src=\"../assets/img/Line_application_logo.svg_.png\"/>\n<style>\n    .modal-content{\n      background :transparent !important;\n    }\n</style>\n<ng-template #template2 style=\"width: 400px;\">\n \n      <div class=\"modal-body\">\n          <img src=\"../../assets/img/qrline.jpg\" alt=\"\" style=\"margin: 0 auto;\n          display: block;\">\n      </div>\n</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/modal-line/modal-line.component.html
// module id = ../../../../../src/app/components/modal-line/modal-line.component.html
// module chunks = main